/**
 * Updates static Tabby installment amount when the PDP variant changes.
 */
(function () {
  const MIN_DEFAULT = 10000;
  const MAX_DEFAULT = 750000;

  function formatMoney(cents, currency) {
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'AED',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function installmentCents(priceCents) {
    return Math.floor(priceCents / 4);
  }

  function updatePromo(root, priceCents) {
    const min = parseInt(root.dataset.minCents, 10) || MIN_DEFAULT;
    const max = parseInt(root.dataset.maxCents, 10) || MAX_DEFAULT;
    const amountEl = root.querySelector('[data-tabby-installment]');
    if (!amountEl) return;

    if (!priceCents || priceCents < min || priceCents > max) {
      root.hidden = true;
      return;
    }

    root.hidden = false;
    amountEl.textContent = formatMoney(installmentCents(priceCents), root.dataset.currency);
  }

  function init() {
    const promos = document.querySelectorAll('[data-grail-tabby-promo]');
    if (!promos.length) return;

    /* Liquid already set amount + hidden. Re-running here toggled [hidden]
       after first paint and shifted everything under the price (CLS). */

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const variant = event?.data?.variant;
      if (!sectionId || !variant || typeof variant.price !== 'number') return;

      promos.forEach((root) => {
        if (root.dataset.sectionId !== String(sectionId)) return;
        updatePromo(root, variant.price);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
